<template>
  <nav :style="'height: 65px; background-color:'+this.$store.state.empresa.cor_primaria">
    <div class="nav-wrapper  " style="padding-left: 10px;">
      <a class=" button-larges" >
        &nbsp;<i class="fas fa-arrow-left"  @click="Voltar()" :style="'padding-right: 15px;'+colorarrow ? 'color:'+colorarrow : ''">&nbsp;&nbsp;{{titulo}}</i>
      </a>
      <slot></slot>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "MenuSuperior",
    props:["titulo","colorarrow"],
    methods:{
      Voltar() {
        const previousRoute = this.$router.resolve(this.$router.history.current.fullPath).route;

        if (previousRoute && previousRoute.query.produto) {
          this.$router.push("/" + this.$store.state.empresa_url + "/menu");
        }

        this.$router.back();
      }
    }
  }
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.box div {
  width: 100%;
  height: 40px;
}


.button-larges{
  text-decoration: none;
  display: inline-block;
  text-align:center;
  font-size: 14px;
  /*font-weight: bold;*/
  line-height: 15px;
  padding: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.button-larges i{
  font-size: 15px;
}

</style>



// WEBPACK FOOTER //
// src/app/views/template/MenuSuperior.vue